import { useContext, useEffect, useState } from "react";
import { ContextStatus } from "@leedpulse-monorepo/enums";
import getLiveStats, { LiveStats } from "../../../domain/use_cases/leedflow/overview/getLiveStats";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

/** Cadence du rafraîchissement du bloc « Maintenant ». */
const REFRESH_MS = 30_000;

export const useLeedflowLiveStats = (subscriptionIds?: string[], exclude?: string[]) => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;
    const [stats, setStats] = useState<LiveStats>({ callsInProgress: 0, activeLines: 0, windowMinutes: 15 });
    // LOADING dès l'état initial, et jamais reposé ensuite : un squelette qui
    // réapparaît toutes les 30 secondes fait clignoter le bloc pour rien.
    const [status, setStatus] = useState<ContextStatus>(ContextStatus.LOADING);

    useEffect(() => {
        if (!auth) return;

        let cancelled = false;

        const load = async () => {
            try {
                const res = await getLiveStats(auth, subscriptionIds, exclude);
                if (cancelled) return;
                setStats(res);
                setStatus(ContextStatus.SUCCESS);
            } catch (error) {
                if (cancelled) return;
                console.error(error);
                setStatus(ContextStatus.ERROR);
            }
        };

        // Premier appel immédiat puis toutes les 30 s. `cancelled` évite qu'une
        // réponse arrivée après un changement de filtre écrase la nouvelle.
        load();
        const timer = setInterval(load, REFRESH_MS);

        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [auth, subscriptionIds, exclude]);

    return { stats, status };
};
